module.exports = __webpack_public_path__ + "static/media/Dennis_Rekic.cd9454a1.jpeg";